import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from './HeroSection';
import MazeVsDirectSection from './MazeVsDirectSection';
import AISalesTeamSection from './AISalesTeamSection';
import HowItWorksSection from './HowItWorksSection';
import CustomizationSection from './CustomizationSection';
import NumbersLiveSection from './NumbersLiveSection';
import ClosingCTASection from './ClosingCTASection';
import FAQSection from './FAQSection';
import DemoBookingModal from './DemoBookingModal';

const LandingPage: React.FC = () => {
  const [showDemoModal, setShowDemoModal] = useState(false);

  const handleOpenDemoModal = () => {
    setShowDemoModal(true);
  };

  const handleCloseDemoModal = () => {
    setShowDemoModal(false);
  };

  return (
    <>
      <div className="min-h-screen bg-page-bg relative overflow-hidden landing-page-scrollbars">
        <HeroSection onOpenDemoModal={handleOpenDemoModal} />
        <MazeVsDirectSection />
        <AISalesTeamSection />
        <HowItWorksSection />
        <CustomizationSection onOpenDemoModal={handleOpenDemoModal} />
        <NumbersLiveSection />
        <ClosingCTASection onOpenDemoModal={handleOpenDemoModal} />
        <FAQSection />

        <footer className="border-t border-card-border mt-0 py-8 px-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center space-x-3">
              <img src="/landing-page/salespad logo.svg" alt="SalesPad" className="w-5 h-5" />
              <span className="text-text-secondary text-sm font-medium font-inter">SalesPad &copy; {new Date().getFullYear()} SALESPAD PTE. LTD.</span>
            </div>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-text-secondary text-sm hover:text-text-primary transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-text-secondary text-sm hover:text-text-primary transition-colors duration-200">
                Terms &amp; Conditions
              </Link>
            </div>
          </div>
        </footer>
      </div>
      
      <DemoBookingModal 
        isOpen={showDemoModal} 
        onClose={handleCloseDemoModal} 
      />
    </>
  );
};

export default LandingPage;